import gql from 'graphql-tag';

export default gql`
    query GetCarrierListCSV($input: CarrierMasterDataInput) {
        getCarrierListCSV(input: $input) {
            csv
        }
    }
`;
